export type TierRestriction = 'Free' | 'AnyPremium' | 'ProAndUp';

export const TierRestrictionKeys: TierRestriction[] = ['Free', 'AnyPremium', 'ProAndUp'];

export const TierRestrictions: Record<TierRestriction, string> = {
   Free: 'Free',
   AnyPremium: 'Any Premium',
   ProAndUp: 'Pro and Up',
};
